/** A task chat's input goes to its worker, never to a new Denker turn:
 *  a native sub-agent, or a direct coding-app session (Claude, Codex,
 *  OpenCode). The backend routes the send by conversation identity. */
export type TaskChatKind = "native" | "direct";

/** The task-chat kind of a durable conversation, from its context key. */
export function taskChatKind(
  contextKey: string | null | undefined,
): TaskChatKind | null {
  if (contextKey?.startsWith("native:")) return "native";
  if (contextKey?.startsWith("direct:")) return "direct";
  return null;
}

/** The task-chat kind a conversation frame was opened with, if any. */
export function frameTaskChat(
  metadata: Record<string, unknown>,
): TaskChatKind | null {
  const kind = metadata.taskChat;
  return kind === "native" || kind === "direct" ? kind : null;
}
